module.exports = __webpack_public_path__ + "static/media/implants.629b6ebf.svg";